import React from 'react';
import ClosePayable from '../../../common/poppers/ClosePayable';
import DeleteObject from '../../../common/poppers/DeleteObject';
import PayableDetail from '../../../common/poppers/details/PayableDetail';
import GroupForPayable from '../../../common/poppers/GroupForPayable';
import ManualMatcherForPayable from '../../../common/poppers/ManualMatcherForPayable';
import Matcher from '../../../common/poppers/MatcherForPayable';
import RemovePayableFromGroup from '../../../common/poppers/RemovePayableFromGroup';
import ModifyTax from './ModifyTax';
import TaxRow from './TaxRow';

export const taxActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Előírás módosítása",
        actionComponent: (props, close) => <ModifyTax {...props} close={close} />
    },    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Előírás törlése",
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/tax'} comp={<TaxRow {...props} />} />
    },    {
        dataDialog: "transaction-dialog",
        title: "Linkel",
        dialogTitle: "Linkel",
        canShow: (row) => "MATCH_FOUND" === row.state,
        actionComponent: (props, close) => <Matcher {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, {
        dataDialog: "transaction-dialog",
        title: "Manuális linkel",
        dialogTitle: "Manuális linkel",
        width: "lg",
        canShow: (row) => "NEW" === row.state || "INCOMPLETE" === row.state,
        actionComponent: (props, close) => <ManualMatcherForPayable {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, {
        dataDialog: "group-dialog",
        title: "Előírás linkel",
        dialogTitle: "Előírás linkel",
        canShow: (row) => "PAID" !== row.state && "CLOSED" !== row.state && !row.groupPublicId,
        actionComponent: (props, close) => <GroupForPayable {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, {
        dataDialog: "remove-group-dialog",
        title: "Csoportból eltávolít",
        dialogTitle: "Csoportból eltávolít",
        canShow: (row) => row.groupPublicId,
        actionComponent: (props, close) => <RemovePayableFromGroup {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, {
        dataDialog: "close-dialog",
        title: "Lezárás",
        dialogTitle: "Adó Lezárása",
        canShow: (row) => "PAID" !== row.state && "CLOSED" !== row.state,
        actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={true} confirm={"Biztos hogy le szeretnéd zárni?"} comp={<TaxRow {...props} />} />
    }, {
        dataDialog: "close-dialog",
        title: "Újranyitás",
        dialogTitle: "Adó Újranyitása",
        canShow: (row) => "CLOSED" === row.state,
        actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={false} confirm={"Biztos hogy újra szeretnéd nyitni?"} comp={<TaxRow {...props} />} />
    }, {
        dataDialog: "detail-dialog",
        title: "Részletek",
        dialogTitle: "Részletek",
        width: "lg",
        actionComponent: (props, close) => <PayableDetail {...props} close={close} row={props.row} billtype={props.tabletype} />
    }
]